import _mergeJSXProps from 'babel-helper-vue-jsx-merge-props';
import _extends from 'babel-runtime/helpers/extends';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
/* eslint-disable camelcase */
import shallowequal from 'shallowequal';
import merge from 'lodash/merge';
import classes from 'component-classes';
import classNames from 'classnames';
import PropTypes from '../../_util/vue-types';
import { debounce } from './utils';
import warning from '../../_util/warning';
import addEventListener from '../../vc-util/Dom/addEventListener';
import { Provider, create } from '../../_util/store';
import ColumnManager from './ColumnManager';
import HeadTable from './HeadTable';
import BodyTable from './BodyTable';
import ExpandableTable from './ExpandableTable';
import { initDefaultProps, getOptionProps, getListeners } from '../../_util/props-util';
import BaseMixin from '../../_util/BaseMixin';
import Checkbox from '../../checkbox';
import { measureScrollbar } from './utils';

export default {
  name: 'Table',
  mixins: [BaseMixin],
  props: initDefaultProps({
    data: PropTypes.array,
    useFixedHeader: PropTypes.bool,
    columns: PropTypes.array,
    prefixCls: PropTypes.string,
    bodyStyle: PropTypes.object,
    rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    rowClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    customRow: PropTypes.func,
    customHeaderRow: PropTypes.func,
    // onRowClick: PropTypes.func,
    // onRowDoubleClick: PropTypes.func,
    // onRowContextMenu: PropTypes.func,
    // onRowMouseEnter: PropTypes.func,
    // onRowMouseLeave: PropTypes.func,
    showHeader: PropTypes.bool,
    title: PropTypes.func,
    id: PropTypes.string,
    footer: PropTypes.func,
    emptyText: PropTypes.any,
    scroll: PropTypes.object,
    rowRef: PropTypes.func,
    getBodyWrapper: PropTypes.func,
    components: PropTypes.shape({
      table: PropTypes.any,
      header: PropTypes.shape({
        wrapper: PropTypes.any,
        row: PropTypes.any,
        cell: PropTypes.any
      }),
      body: PropTypes.shape({
        wrapper: PropTypes.any,
        row: PropTypes.any,
        cell: PropTypes.any
      })
    }),
    expandIconAsCell: PropTypes.bool,
    expandedRowKeys: PropTypes.array,
    expandedRowClassName: PropTypes.func,
    defaultExpandAllRows: PropTypes.bool,
    defaultExpandedRowKeys: PropTypes.array,
    expandIconColumnIndex: PropTypes.number,
    expandedRowRender: PropTypes.func,
    childrenColumnName: PropTypes.string,
    indentSize: PropTypes.number,
    expandRowByClick: PropTypes.bool,
    expandIcon: PropTypes.func,
    tableLayout: PropTypes.string,
    transformCellText: PropTypes.func,
    rowDraggable: PropTypes.object,
    dataSource: PropTypes.array,
    sortOrder: PropTypes.string,
    virtual: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    group: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    selectedRowKeys: PropTypes.array,
    rowSelection: PropTypes.object,
    groupFooter: PropTypes.func,
    groupTitle: PropTypes.func,
    emptyCellText: PropTypes.string
  }, {
    data: [],
    useFixedHeader: false,
    rowKey: 'key',
    rowClassName: function rowClassName() {
      return '';
    },
    prefixCls: 'rc-table',
    bodyStyle: {},
    showHeader: true,
    scroll: {},
    rowRef: function rowRef() {
      return null;
    },
    emptyText: function emptyText() {
      return 'No Data';
    },
    customHeaderRow: function customHeaderRow() {}
  }),
  data: function data() {
    this.preData = [].concat(_toConsumableArray(this.data));
    return {
      columnManager: new ColumnManager(this.columns),
      sComponents: merge({
        table: 'table',
        header: {
          wrapper: 'thead',
          row: 'tr',
          cell: 'th'
        },
        body: {
          wrapper: 'tbody',
          row: 'tr',
          cell: 'td'
        }
      }, this.components),
      baseTableWrapperPaddingTop: 0,
      baseTableWrapperPaddingBottom: 0
    };
  },

  watch: {
    components: function components() {
      this._components = merge({
        table: 'table',
        header: {
          wrapper: 'thead',
          row: 'tr',
          cell: 'th'
        },
        body: {
          wrapper: 'tbody',
          row: 'tr',
          cell: 'td'
        }
      }, this.components);
    },
    columns: function columns(val) {
      if (val) {
        this.columnManager.reset(val);
      }
    },
    data: function data(val) {
      var _this = this;

      if (val.length === 0 && this.hasScrollX()) {
        this.$nextTick(function () {
          _this.resetScrollX();
        });
      }
    }
  },

  // static childContextTypes = {
  //   table: PropTypes.any,
  //   components: PropTypes.any,
  // },

  created: function created() {
    var _this2 = this;

    ['rowClick', 'rowDoubleclick', 'rowContextmenu', 'rowMouseenter', 'rowMouseleave'].forEach(function (name) {
      warning(getListeners(_this2)[name] === undefined, name + ' is deprecated, please use customRow instead.');
    });

    warning(this.getBodyWrapper === undefined, 'getBodyWrapper is deprecated, please use custom components instead.');

    // this.columnManager = new ColumnManager(this.columns, this.$slots.default)

    this.store = create({
      currentHoverKey: null,
      fixedColumnsHeadRowsHeight: [],
      fixedColumnsBodyRowsHeight: {}
    });

    this.setScrollPosition('left');

    this.debouncedWindowResize = debounce(this.handleWindowResize, 150);
  },
  provide: function provide() {
    return {
      table: this
    };
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.setGroupTableHeader();
      _this3.setScrollXListener();

      if (_this3.columnManager.isAnyColumnsFixed()) {
        _this3.handleWindowResize();
        _this3.resizeEvent = addEventListener(window, 'resize', _this3.debouncedWindowResize);
      }
      // https://github.com/ant-design/ant-design/issues/11635
      if (_this3.ref_headTable) {
        _this3.ref_headTable.scrollLeft = 0;
      }
      if (_this3.ref_bodyTable) {
        _this3.ref_bodyTable.scrollLeft = 0;
      }
      // 修复表格内容区内容没有超出依然出现横向滚动条的问题
      // 修复表格内容区内容没有超出依然出现纵向滚动条的问题
      _this3.fixedTableScrollBarStyle();
      // 修复表格固定列时明明没超出却显示阴影的问题
      _this3.setGroupTableScrollBar();
    });
  },
  updated: function updated() {
    var _this4 = this;

    this.$nextTick(function () {
      if (_this4.columnManager.isAnyColumnsFixed()) {
        _this4.handleWindowResize();
        if (!_this4.resizeEvent) {
          _this4.resizeEvent = addEventListener(window, 'resize', _this4.debouncedWindowResize);
        }
      }
      // 分组
      _this4.setGroupHeaderFixedRight();
      _this4.setGroupTableHeader();
      _this4.setScrollXListener();
      // 修复表格固定列时明明没超出却显示阴影的问题
      _this4.setGroupTableScrollBar();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.resizeEvent) {
      this.resizeEvent.remove();
    }
    if (this.debouncedWindowResize) {
      this.debouncedWindowResize.cancel();
    }
  },

  methods: {
    getRowKey: function getRowKey(record, index) {
      var rowKey = this.rowKey;
      var key = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
      warning(key !== undefined, 'Each record in table should have a unique `key` prop,' + 'or set `rowKey` to an unique primary key.');
      return key === undefined ? index : key;
    },
    setScrollPosition: function setScrollPosition(position) {
      this.scrollPosition = position;
      if (this.tableNode) {
        var prefixCls = this.prefixCls;

        if (position === 'both') {
          classes(this.tableNode).remove(new RegExp('^' + prefixCls + '-scroll-position-.+$')).add(prefixCls + '-scroll-position-left').add(prefixCls + '-scroll-position-right');
        } else {
          classes(this.tableNode).remove(new RegExp('^' + prefixCls + '-scroll-position-.+$')).add(prefixCls + '-scroll-position-' + position);
        }
      }
    },
    setScrollPositionClassName: function setScrollPositionClassName() {
      var node = this.ref_bodyTable;
      var scrollToLeft = node.scrollLeft === 0;
      var scrollToRight = node.scrollLeft + 1 >= node.children[0].getBoundingClientRect().width - node.getBoundingClientRect().width;
      if (scrollToLeft && scrollToRight) {
        this.setScrollPosition('both');
      } else if (scrollToLeft) {
        this.setScrollPosition('left');
      } else if (scrollToRight) {
        this.setScrollPosition('right');
      } else if (this.scrollPosition !== 'middle') {
        this.setScrollPosition('middle');
      }
    },
    isTableLayoutFixed: function isTableLayoutFixed() {
      var _$props = this.$props,
          tableLayout = _$props.tableLayout,
          _$props$columns = _$props.columns,
          columns = _$props$columns === undefined ? [] : _$props$columns,
          useFixedHeader = _$props.useFixedHeader,
          _$props$scroll = _$props.scroll,
          scroll = _$props$scroll === undefined ? {} : _$props$scroll;

      if (typeof tableLayout !== 'undefined') {
        return tableLayout === 'fixed';
      }
      // if one column is ellipsis, use fixed table layout to fix align issue
      if (columns.some(function (_ref) {
        var ellipsis = _ref.ellipsis;
        return !!ellipsis;
      })) {
        return true;
      }
      // if header fixed, use fixed table layout to fix align issue
      if (useFixedHeader || scroll.y) {
        return true;
      }
      // if scroll.x is number/px/% width value, we should fixed table layout
      // to avoid long word layout broken issue
      if (scroll.x && scroll.x !== true && scroll.x !== 'max-content') {
        return true;
      }
      return false;
    },
    handleWindowResize: function handleWindowResize() {
      if (!this.group) {
        this.syncFixedTableRowHeight();
        this.setScrollPositionClassName(); // 分组表格使用onGroupScroll实现
      }
      // 修复表格内容区内容没有超出依然出现横向滚动条的问题
      // 修复表格内容区内容没有超出依然出现纵向滚动条的问题
      this.fixedTableScrollBarStyle();
    },
    syncFixedTableRowHeight: function syncFixedTableRowHeight() {
      var tableRect = this.tableNode.getBoundingClientRect();
      // If tableNode's height less than 0, suppose it is hidden and don't recalculate rowHeight.
      // see: https://github.com/ant-design/ant-design/issues/4836
      if (tableRect.height !== undefined && tableRect.height <= 0) {
        return;
      }
      var prefixCls = this.prefixCls;

      var headRows = this.ref_headTable ? this.ref_headTable.querySelectorAll('thead') : this.ref_bodyTable.querySelectorAll('thead');
      var bodyRows = this.ref_bodyTable.querySelectorAll('.' + prefixCls + '-row') || [];
      var fixedColumnsHeadRowsHeight = [].map.call(headRows, function (row) {
        return row.getBoundingClientRect().height ? row.getBoundingClientRect().height - 0.5 : 'auto';
      });
      var state = this.store.getState();
      var fixedColumnsBodyRowsHeight = [].reduce.call(bodyRows, function (acc, row) {
        var rowKey = row.getAttribute('data-row-key');
        var height = row.getBoundingClientRect().height || state.fixedColumnsBodyRowsHeight[rowKey] || 'auto';
        acc[rowKey] = height;
        return acc;
      }, {});
      if (shallowequal(state.fixedColumnsHeadRowsHeight, fixedColumnsHeadRowsHeight) && shallowequal(state.fixedColumnsBodyRowsHeight, fixedColumnsBodyRowsHeight)) {
        return;
      }
      this.store.setState({
        fixedColumnsHeadRowsHeight: fixedColumnsHeadRowsHeight,
        fixedColumnsBodyRowsHeight: fixedColumnsBodyRowsHeight
      });
    },
    fixedTableScrollBarStyle: function fixedTableScrollBarStyle() {
      if (this.group) return;
      var props = getOptionProps(this);
      var ref_bodyTable = this.ref_bodyTable,
          ref_fixedColumnsBodyLeft = this.ref_fixedColumnsBodyLeft,
          ref_fixedColumnsBodyRight = this.ref_fixedColumnsBodyRight;


      if (ref_bodyTable && (ref_fixedColumnsBodyLeft || ref_fixedColumnsBodyRight)) {
        if (ref_bodyTable.clientWidth === ref_bodyTable.scrollWidth) {
          ref_bodyTable.style.overflowX = 'auto';

          ref_fixedColumnsBodyLeft && (ref_fixedColumnsBodyLeft.style.overflowX = 'auto');
          ref_fixedColumnsBodyRight && (ref_fixedColumnsBodyRight.style.overflowX = 'auto');
        } else {
          ref_bodyTable.style.overflowX && (ref_bodyTable.style.overflowX = 'scroll');

          if (ref_fixedColumnsBodyLeft) {
            ref_fixedColumnsBodyLeft.style.overflowX && (ref_fixedColumnsBodyLeft.style.overflowX = 'scroll');
          }

          if (ref_fixedColumnsBodyRight) {
            ref_fixedColumnsBodyRight.style.overflowX && (ref_fixedColumnsBodyRight.style.overflowX = 'scroll');
          }
        }
      }

      if (ref_bodyTable && props.scroll && props.scroll.y) {
        if (ref_bodyTable.clientHeight === ref_bodyTable.scrollHeight) {
          ref_bodyTable.style.overflowY = 'auto';

          ref_fixedColumnsBodyLeft && (ref_fixedColumnsBodyLeft.style.overflowY = 'auto');
          ref_fixedColumnsBodyRight && (ref_fixedColumnsBodyRight.style.overflowY = 'auto');
        } else {
          ref_bodyTable.style.overflowY && (ref_bodyTable.style.overflowY = 'scroll');

          if (ref_fixedColumnsBodyLeft) {
            ref_fixedColumnsBodyLeft.style.overflowY && (ref_fixedColumnsBodyLeft.style.overflowY = 'scroll');
          }

          if (ref_fixedColumnsBodyRight) {
            ref_fixedColumnsBodyRight.style.overflowY && (ref_fixedColumnsBodyRight.style.overflowY = 'scroll');
          }
        }
      }
    },
    resetScrollX: function resetScrollX() {
      if (this.ref_headTable) {
        this.ref_headTable.scrollLeft = 0;
      }
      if (this.ref_bodyTable) {
        this.ref_bodyTable.scrollLeft = 0;
      }
    },
    hasScrollX: function hasScrollX() {
      var _scroll = this.scroll,
          scroll = _scroll === undefined ? {} : _scroll;

      return 'x' in scroll;
    },
    handleBodyScrollLeft: function handleBodyScrollLeft(e) {
      // Fix https://github.com/ant-design/ant-design/issues/7635
      if (e.currentTarget !== e.target) {
        return;
      }
      var target = e.target;
      var _scroll2 = this.scroll,
          scroll = _scroll2 === undefined ? {} : _scroll2;
      var ref_headTable = this.ref_headTable,
          ref_bodyTable = this.ref_bodyTable;

      if (target.scrollLeft !== this.lastScrollLeft && scroll.x) {
        if (target === ref_bodyTable && ref_headTable) {
          ref_headTable.scrollLeft = target.scrollLeft;
        } else if (target === ref_headTable && ref_bodyTable) {
          ref_bodyTable.scrollLeft = target.scrollLeft;
        }
        this.setScrollPositionClassName();
      }
      // Remember last scrollLeft for scroll direction detecting.
      this.lastScrollLeft = target.scrollLeft;
    },
    handleBodyScrollTop: function handleBodyScrollTop(e) {
      var target = e.target;
      // Fix https://github.com/ant-design/ant-design/issues/9033
      if (e.currentTarget !== target) {
        return;
      }
      var _scroll3 = this.scroll,
          scroll = _scroll3 === undefined ? {} : _scroll3;
      var ref_headTable = this.ref_headTable,
          ref_bodyTable = this.ref_bodyTable,
          ref_fixedColumnsBodyLeft = this.ref_fixedColumnsBodyLeft,
          ref_fixedColumnsBodyRight = this.ref_fixedColumnsBodyRight;

      if (target.scrollTop !== this.lastScrollTop && scroll.y && target !== ref_headTable) {
        var scrollTop = target.scrollTop;
        if (ref_fixedColumnsBodyLeft && target !== ref_fixedColumnsBodyLeft) {
          ref_fixedColumnsBodyLeft.scrollTop = scrollTop;
        }
        if (ref_fixedColumnsBodyRight && target !== ref_fixedColumnsBodyRight) {
          ref_fixedColumnsBodyRight.scrollTop = scrollTop;
        }
        if (ref_bodyTable && target !== ref_bodyTable) {
          ref_bodyTable.scrollTop = scrollTop;
        }
      }
      // Remember last scrollTop for scroll direction detecting.
      this.lastScrollTop = target.scrollTop;
    },
    handleBodyScroll: function handleBodyScroll(e) {
      this.handleBodyScrollLeft(e);
      this.handleBodyScrollTop(e);
    },
    handleWheel: function handleWheel(event) {
      var _$props$scroll2 = this.$props.scroll,
          scroll = _$props$scroll2 === undefined ? {} : _$props$scroll2;

      if (window.navigator.userAgent.match(/Trident\/7\./) && scroll.y) {
        event.preventDefault();
        var wd = event.deltaY;
        var target = event.target;
        var bodyTable = this.ref_bodyTable,
            fixedColumnsBodyLeft = this.ref_fixedColumnsBodyLeft,
            fixedColumnsBodyRight = this.ref_fixedColumnsBodyRight;

        var scrollTop = 0;
        if (this.lastScrollTop) {
          scrollTop = this.lastScrollTop + wd;
        } else {
          scrollTop = wd;
        }

        if (fixedColumnsBodyLeft && target !== fixedColumnsBodyLeft) {
          fixedColumnsBodyLeft.scrollTop = scrollTop;
        }
        if (fixedColumnsBodyRight && target !== fixedColumnsBodyRight) {
          fixedColumnsBodyRight.scrollTop = scrollTop;
        }
        if (bodyTable && target !== bodyTable) {
          bodyTable.scrollTop = scrollTop;
        }
      }
    },

    // saveChildrenRef(name, node) {
    //   this[`ref_${name}`] = node;
    // },
    saveRef: function saveRef(name) {
      var _this5 = this;

      return function (node) {
        _this5['ref_' + name] = node;
      };
    },
    saveTableNodeRef: function saveTableNodeRef(node) {
      this.tableNode = node;
    },
    renderMainTable: function renderMainTable(_ref2) {
      var groupIndex = _ref2.groupIndex,
          groupData = _ref2.groupData;
      var h = this.$createElement;
      var scroll = this.scroll,
          prefixCls = this.prefixCls;

      var isAnyColumnsFixed = this.columnManager.isAnyColumnsFixed();
      var scrollable = isAnyColumnsFixed || scroll.x || scroll.y;
      var table = [this.renderTable({
        columns: this.columnManager.groupedColumns(),
        isAnyColumnsFixed: isAnyColumnsFixed,
        groupIndex: groupIndex
      }), this.renderEmptyText(), this.renderFooter(groupIndex, groupData)];
      return scrollable ? h(
        'div',
        { 'class': prefixCls + '-scroll' },
        [table]
      ) : table;
    },
    renderLeftFixedTable: function renderLeftFixedTable(groupIndex) {
      var h = this.$createElement;
      var prefixCls = this.prefixCls;


      return h(
        'div',
        { 'class': prefixCls + '-fixed-left' },
        [this.renderTable({
          columns: this.columnManager.leftColumns(),
          fixed: 'left',
          groupIndex: groupIndex
        })]
      );
    },
    renderRightFixedTable: function renderRightFixedTable(groupIndex) {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          group = this.group,
          scroll = this.scroll;

      // 分组固定列滚动条宽度补齐

      var groupStyle = {};
      var groupClass = '';
      if (group && !groupIndex && scroll && scroll.y) {
        var scrollbarWidth = measureScrollbar({ direction: 'vertical' });
        groupStyle.paddingRight = scrollbarWidth + 'px';
        groupClass = prefixCls + '-fixed-right-group';
      }

      return h(
        'div',
        { 'class': [prefixCls + '-fixed-right', groupClass], style: groupStyle },
        [this.renderTable({
          columns: this.columnManager.rightColumns(),
          fixed: 'right',
          groupIndex: groupIndex
        })]
      );
    },
    renderTable: function renderTable(options) {
      var h = this.$createElement;
      var columns = options.columns,
          fixed = options.fixed,
          isAnyColumnsFixed = options.isAnyColumnsFixed,
          groupIndex = options.groupIndex;
      var prefixCls = this.prefixCls,
          _scroll4 = this.scroll,
          scroll = _scroll4 === undefined ? {} : _scroll4;

      var tableClassName = scroll.x || fixed ? prefixCls + '-fixed' : '';

      var headTable = h(HeadTable, {
        key: 'head',
        attrs: { columns: columns,
          fixed: fixed,
          tableClassName: tableClassName,
          handleBodyScrollLeft: this.handleBodyScrollLeft,
          expander: this.expander,
          groupIndex: groupIndex
        }
      });

      var bodyTable = groupIndex === 0 ? null : h(BodyTable, {
        key: 'body',
        attrs: { columns: columns,
          fixed: fixed,
          tableClassName: tableClassName,
          getRowKey: this.getRowKey,
          handleWheel: this.handleWheel,
          handleBodyScroll: this.handleBodyScroll,
          expander: this.expander,
          isAnyColumnsFixed: isAnyColumnsFixed,
          groupIndex: groupIndex - 1
        }
      });

      return [headTable, bodyTable];
    },
    renderTitle: function renderTitle(_ref3) {
      var groupIndex = _ref3.groupIndex,
          _ref3$groupData = _ref3.groupData,
          groupData = _ref3$groupData === undefined ? {} : _ref3$groupData;
      var h = this.$createElement;
      var title = this.title,
          prefixCls = this.prefixCls,
          data = this.data,
          group = this.group,
          rowSelection = this.rowSelection,
          slotGroupTitle = this.groupTitle,
          renderGroupCheckBox = this.renderGroupCheckBox;

      var titleList = title ? [h(
        'div',
        { 'class': prefixCls + '-title', key: 'title' },
        [title(data)]
      )] : [];
      // 自定义分组头部
      if (group && groupIndex) {
        titleList.length && titleList.pop();
        // 自定义渲染
        if (!group.tableMode) {
          var selectGroupData = groupData.groupData,
              groupTitle = groupData.groupTitle;


          var titleText = slotGroupTitle ? slotGroupTitle({ groupData: groupData, groupIndex: groupIndex }) || groupTitle : groupTitle;
          titleList.unshift(h(
            'div',
            { 'class': prefixCls + '-group-title', key: 'groupTitle' },
            [rowSelection && !group.hideSelection && renderGroupCheckBox(selectGroupData), titleText && h(
              'div',
              { 'class': prefixCls + '-group-title__title-text' },
              [titleText]
            )]
          ));
        }
      }
      return titleList;
    },
    renderFooter: function renderFooter(groupIndex) {
      var groupData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var h = this.$createElement;
      var footer = this.footer,
          prefixCls = this.prefixCls,
          data = this.data,
          group = this.group,
          groupFooter = this.groupFooter;

      var footerList = footer ? [h(
        'div',
        { 'class': prefixCls + '-footer', key: 'footer' },
        [footer(data)]
      )] : [];
      // 自定义分组底部
      if (group) {
        groupIndex !== data.length && footerList.length && footerList.pop();
        if (groupIndex) {
          var footerText = groupFooter ? groupFooter({ groupData: groupData, groupIndex: groupIndex }) || groupData.groupFooter : groupData.groupFooter;

          if (footerText) {
            footerList.unshift(h(
              'div',
              { 'class': prefixCls + '-group-footer', key: 'groupFooter' },
              [h(
                'div',
                { 'class': prefixCls + '-group-footer__footer-text' },
                [footerText]
              )]
            ));
          }
        }
      }
      return footerList;
    },
    renderEmptyText: function renderEmptyText() {
      var h = this.$createElement;
      var emptyText = this.emptyText,
          prefixCls = this.prefixCls,
          data = this.data;

      if (data.length) {
        return null;
      }
      var emptyClassName = prefixCls + '-placeholder';
      return h(
        'div',
        { 'class': emptyClassName, key: 'emptyText' },
        [typeof emptyText === 'function' ? emptyText() : emptyText]
      );
    },


    // 渲染group选择框
    renderGroupCheckBox: function renderGroupCheckBox(selectGroupData) {
      var _this6 = this;

      var h = this.$createElement;
      var tableMode = this.group.tableMode;

      var setCheck = function setCheck() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'every';
        return selectGroupData[event](function (it) {
          return _this6.selectedRowKeys.includes(it.key);
        });
      };
      var checked = setCheck();
      var indeterminate = !checked && setCheck('some');
      var checkboxProps = {
        props: {
          checked: checked,
          indeterminate: indeterminate
        },
        on: {
          change: function change(e) {
            var checked = e.target.checked;

            _this6.$emit('select', 'selectGroup', 0, null, {
              checked: checked,
              selectGroupKeys: selectGroupData.map(function (it) {
                return it.key;
              })
            });
          }
        }
      };
      return h(
        'div',
        {
          'class': [this.prefixCls + '-group-title__checkbox', !tableMode && this.prefixCls + '-group-title__checkbox--customHeader']
        },
        [h(Checkbox, checkboxProps)]
      );
    },


    // 分组
    onGroupScroll: function onGroupScroll(e) {
      if (!this.scroll.x) return;
      var _e$target = e.target,
          scrollLeft = _e$target.scrollLeft,
          clientWidth = _e$target.clientWidth,
          scrollWidth = _e$target.scrollWidth;

      var headerEl = this.$el.querySelector('.fa-table-group-table__header .fa-table-hide-scrollbar');
      var els = this.$el.querySelectorAll('.fa-table-body');
      headerEl.scrollLeft = scrollLeft;
      els.forEach(function (it) {
        it.scrollLeft = scrollLeft;
      });

      // 固定列样式名一致
      var tableList = this.$el.querySelectorAll('.fa-table');
      if (tableList.length) {
        var preClass = 'fa-table-scroll-position';
        var addClass = function addClass(el, type) {
          var className = preClass + '-' + type;
          el.classList.add(className);
        };
        for (var index = 0; index < tableList.length; index++) {
          var item = tableList[index];
          if (!scrollLeft) {
            item.classList.remove(preClass + '-middle');
            item.classList.remove(preClass + '-right');
            addClass(item, 'left');
          } else if (clientWidth + scrollLeft === scrollWidth) {
            item.classList.remove(preClass + '-left');
            addClass(item, 'right');
          } else {
            item.classList.remove(preClass + '-left');
            addClass(item, 'middle');
          }
        }
      }
    },


    // 重置分组列表头部右侧固定列padding
    setGroupHeaderFixedRight: function setGroupHeaderFixedRight() {
      var group = this.group,
          prefixCls = this.prefixCls,
          scroll = this.scroll;

      if (group && scroll && scroll.y) {
        var scrollTable = this.$el.querySelector('.' + prefixCls + '-group-table__all-item');
        var groupFixedRight = this.$el.querySelector('.' + prefixCls + '-fixed-right');
        var scrollbarWidth = measureScrollbar({ direction: 'vertical' });
        var bool = scrollTable && groupFixedRight && scrollTable.scrollHeight <= scroll.y;
        if (groupFixedRight) groupFixedRight.style.paddingRight = bool ? 0 : scrollbarWidth + 'px';
      }
    },

    // 修复无滚动条情况下合并表头bug
    setGroupTableHeader: function setGroupTableHeader() {
      var group = this.group,
          prefixCls = this.prefixCls,
          scroll = this.scroll,
          columns = this.columns;

      if (!group || scroll && scroll.x) return;
      var colgroup = this.$el.querySelector('.' + prefixCls + '-group-table__header .' + prefixCls + '-header colgroup');
      var groupTableTr = this.$el.querySelector('.' + prefixCls + '-group-table__all-item .' + prefixCls + '-content .' + prefixCls + '-row');
      if (!colgroup || !groupTableTr) return;
      var colChildren = colgroup.children;
      var tdChildren = groupTableTr.children;

      columns.forEach(function (it, index) {
        if ('colSpan' in it) {
          var colSpan = it.colSpan;
          if (colSpan > 0) {
            var tds = [].concat(_toConsumableArray(tdChildren)).slice(index, index + colSpan);
            colChildren[index].style.width = tds.reduce(function (a, b) {
              return a + b.offsetWidth;
            }, 0) + 'px';
          }
        }
      });
    },

    // 修复表格固定列时明明没超出却显示阴影的问题
    setGroupTableScrollBar: function setGroupTableScrollBar() {
      var scrollRef = this.$refs.groupTableScrollBar;
      if (!scrollRef) return;

      var realHeight = scrollRef.offsetHeight;
      if (realHeight === 1) {
        // 意味着没有出现横向滚动条，因为css中设置了高度为一
        var tableList = this.$el.querySelectorAll('.fa-table');
        if (tableList.length) {
          for (var i = 0; i < tableList.length; i++) {
            var item = tableList[i];
            classes(item).remove(new RegExp('^' + this.prefixCls + '-scroll-position-.+$')).add(this.prefixCls + '-scroll-position-left').add(this.prefixCls + '-scroll-position-right');
          }
        }
      }
    },

    // 模拟实现shift + 鼠标滚轮横向滚动
    setScrollXListener: function setScrollXListener() {
      var scroll = this.scroll,
          $el = this.$el,
          group = this.group,
          prefixCls = this.prefixCls;

      if (!group || !scroll || !scroll.x) return;
      var scrollEl = $el.querySelector('.' + prefixCls + '-group_scroll-x-wrapper');
      $el.onmousewheel = function (_ref4) {
        var shiftKey = _ref4.shiftKey,
            wheelDelta = _ref4.wheelDelta;

        if (shiftKey) {
          var speed = 30;
          var num = 0;
          var req = void 0;
          var scrollX = function scrollX() {
            num += 5;
            scrollEl.scrollLeft += wheelDelta > 0 ? -num : num;
            if (num > speed) {
              window.cancelAnimationFrame(req);
            } else {
              req = window.requestAnimationFrame(scrollX);
            }
          };
          scrollX();
        }
      };
    }
  },

  render: function render() {
    var _classNames,
        _this7 = this;

    var h = arguments[0];

    var props = getOptionProps(this);
    var columnManager = this.columnManager,
        getRowKey = this.getRowKey,
        renderData = this.data,
        group = this.group;

    var prefixCls = props.prefixCls;
    var groupMargin = group && group.groupMargin;

    var tableClassName = classNames(props.prefixCls, (_classNames = {}, _defineProperty(_classNames, prefixCls + '-fixed-header', props.useFixedHeader || props.scroll && props.scroll.y), _defineProperty(_classNames, prefixCls + '-scroll-position-left ' + prefixCls + '-scroll-position-right', this.scrollPosition === 'both'), _defineProperty(_classNames, prefixCls + '-scroll-position-' + this.scrollPosition, this.scrollPosition !== 'both'), _defineProperty(_classNames, prefixCls + '-layout-fixed', this.isTableLayoutFixed()), _classNames));

    var hasLeftFixed = columnManager.isAnyColumnsLeftFixed();
    var hasRightFixed = columnManager.isAnyColumnsRightFixed();

    var expandableTableProps = {
      props: _extends({}, props, {
        columnManager: columnManager,
        getRowKey: getRowKey
      }),
      on: getListeners(this),
      scopedSlots: {
        'default': function _default(expander) {
          _this7.expander = expander;
          return h(
            'div',
            _mergeJSXProps([{
              directives: [{
                name: 'fa-ref',
                value: _this7.saveTableNodeRef
              }]
            }, {
              'class': tableClassName
              // style={props.style}
              // id={props.id}
            }]),
            [_this7.renderTitle(expander.props), h(
              'div',
              { 'class': prefixCls + '-content' },
              [_this7.renderMainTable(expander.props), hasLeftFixed && _this7.renderLeftFixedTable(expander.props.groupIndex), hasRightFixed && _this7.renderRightFixedTable(expander.props.groupIndex)]
            )]
          );
        }
      }
    };
    var baseEl = function baseEl(groupIndex, groupData) {
      return h(
        Provider,
        {
          attrs: {
            store: _this7.store
          },
          'class': group ? prefixCls + '-group-table' : null,
          style: groupIndex > 1 && groupMargin !== undefined && { marginTop: groupMargin + 'px' }
        },
        [h(ExpandableTable, _mergeJSXProps([expandableTableProps, {
          attrs: { groupIndex: groupIndex, groupData: groupData }
        }]))]
      );
    };
    // 设置分组
    var groupEl = function groupEl() {
      var list = renderData;
      var _scroll5 = _this7.scroll,
          x = _scroll5.x,
          y = _scroll5.y;

      var hasData = renderData.length;

      return h(
        'div',
        { 'class': prefixCls + '-group-table-list' },
        [h(
          'div',
          {
            'class': [prefixCls + '-group-table__header', _this7.scroll ? prefixCls + '-scroll ' + prefixCls + '-group-header-scroll' : '']
          },
          [baseEl(0)]
        ), hasData ? h(
          'div',
          {
            'class': [prefixCls + '-group-table__content', _this7.scroll ? prefixCls + '-scroll ' + prefixCls + '-group-scroll' : ''],
            style: groupMargin !== undefined && { marginTop: groupMargin + 'px' }
          },
          [h(
            'div',
            {
              'class': prefixCls + '-group-table__item-list',
              style: y && { maxHeight: y + 'px' }
            },
            [h(
              'div',
              { 'class': prefixCls + '-group-table__all-item' },
              [list.map(function (it, index) {
                return baseEl(index + 1, it);
              })]
            )]
          )]
        ) : null, x && hasData ? h(
          'div',
          {
            'class': prefixCls + '-group_scroll-x-wrapper',
            on: {
              'scroll': _this7.onGroupScroll
            },

            ref: 'groupTableScrollBar'
          },
          [h('div', { 'class': prefixCls + '-group_scroll-x-bar', style: x && { width: x + 'px' } })]
        ) : null]
      );
    };
    return !group ? baseEl() : groupEl();
  }
};